<template>
  <div class="login-background">
    <div class="login-container">
      <div class="login-content">
        <div class="login-form">
          <div class="logo">
            <img src="/assets/img/logo.png" />
          </div>
          <transition-group name="slide" tag="span">
            <div v-if="!forgotPassword.show" key="1">
              <form @submit.prevent="login">
                <div class="title">BACKOFFICE</div>
                <div v-bind:class="{ 'error-message': true, show: showError }">{{ $t('login.errorLogin') }}</div>
                <div class="login-input">
                  <div class="icon"><i class="fas fa-at"></i></div>
                  <input type="email" :placeholder="$t('login.inputEmail')" v-model="email" />
                </div>
                <div class="login-input password">
                  <div class="icon"><i class="fas fa-key"></i></div>
                  <input type="password" :placeholder="$t('login.inputPassword')" v-model="password" />
                </div>
                <button v-bind:class="{
                  cta: true, block: true,
                  disabled: loggingIn }">
                  <i class="fas fa-circle-notch fa-spin" v-show="loggingIn"></i>
                  <span>{{ loginLabel }}</span>
                </button>
              </form>
              <a class="forgot-link" @click="forgotPassword.show = true" v-show="!forgotPassword.show">{{ $t('login.forgotLink') }}</a>
            </div>

            <div class="forgot-password" v-if="forgotPassword.show" key="2">
              <div class="title">Trouble Logging in?</div>
              <p>Enter your email and we'll send you a recovery link to get back into your account.</p>
              <div :class="{ 'error-message': true, show: forgotPassword.showError }">{{ forgotPassword.errorMsg }}</div>
              <div class="login-input">
                <div class="icon"><i class="fas fa-at"></i></div>
                <input type="email" :placeholder="$t('login.inputEmail')" v-model="email" />
              </div>
              <div :class="{'button cta block success':true, 'disabled':forgotPassword.loading}" @click="sendPassword">
                <span v-if="forgotPassword.loading">
                  <i class="fas fa-circle-notch fa-spin"></i>
                  Loading...
                </span>
                <span v-else>SEND RECOVERY LINK</span>
              </div>
              <a @click="goBack" :class="{'disabled':forgotPassword.loading}">Go Back</a>
            </div>
          </transition-group>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'modal':true, 'show':forgotPassword.success }" @click="close">
      <div class="modal-container">
        <div class="modal-content" @click.stop>
          <label>Reset password link has been sent!</label>
          <p>We have sent a password reset link to your email address:</p>
          <b>{{email}}</b>
          <br />
          <div class="button cta small block" @click="close">Close</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiAdmin from '@/modules/api/admin'
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'
import ApiRoutingReservation from '@/modules/api/routing/reservations'
export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      showError: false,
      loginLabel: this.$t('login.ctaDefault'),
      loggingIn: false,
      forgotPassword: {
        show: false,
        errorMsg: '',
        showError: false,
        loading: false,
        success: false
      }
    }
  },
  methods: {
    login () {
      let self = this
      self.loggingIn = true
      self.showError = false
      self.loginLabel = self.$t('login.ctaLoading')

      // simulated login
      self.$sdk.post('/admin/login', {
        email: self.email,
        password: self.password
      }, r => {
        self.loggingIn = false
        self.loginLabel = self.$t('login.ctaDefault')
        if (r.error) {
          console.log(r.error)
          self.showError = true
          return
        }
        self.$store.commit('session/setUser', {
          id: r.id,
          firstName: r.firstName,
          lastName: r.lastName,
          phone: r.phone,
          email: r.email,
          photoUrl: r.avatarUrl === null? 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg' : r.avatarUrl
        })
        self.$store.commit('session/setSessionToken', r.token)
        self.$plugins.storage.setSessionToken(r.token)
        self.$router.push('/dispatch')
        self.$plugins.fcm.start(self)

        // get RSVP filters
        ApiDispatchReservation.initDispatchReservations(self)
        ApiRoutingReservation.initRoutingReservations(self)
        ApiAdmin.getAdminList(self)
      })
    },
    sendPassword () {
      let self = this

      self.forgotPassword.showError = false
      self.forgotPassword.errorMsg = ''
      if (self.email.trim() === '') {
        self.forgotPassword.errorMsg = 'Please enter email address'
        self.forgotPassword.showError = true
        return
      }

      self.forgotPassword.loading = true
      self.$sdk.delete('/admin/password', { email: self.email }, r => {
        self.forgotPassword.loading = false
        if (r.error) {
          console.log(r.error)
          self.forgotPassword.errorMsg = r.error.message
          self.forgotPassword.showError = true
          return
        }

        self.forgotPassword.success = true
      })
    },
    goBack () {
      if (this.forgotPassword.loading) { return }
      this.forgotPassword.show = false
    },
    close () { location.reload() }
  },
  mounted () {
    let self = this
    self.loggingIn = false
    self.showError = false
    self.loginLabel = this.$t('login.ctaDefault')
    self.$store.commit('sideMenu/hideMenuButton')
  },
  destroyed () {
    this.$store.commit('sideMenu/showMenuButton')
  }
}
</script>

<style lang="scss" scoped>
.login-background{
  background-color: #292931;
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.login-container{
  display: table;
  width: 100%;
  height: 100%;
}

.login-content{
  display: table-cell;
  vertical-align: middle;
  position: relative;
}

.login-form{
  width: 350px;
  min-height: 310px;
  margin: 0 auto;
  background-color: #423142;
  box-shadow: 0 3px 8px rgba(0,0,0,0.5);
  border-radius: 3px;
  padding: 50px 20px 20px;
  position: relative;

  & .title {
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  & .logo {
    width: 120px;
    height: 120px;
    left: calc(50% - 60px);
    display: block;
    position: absolute;
    position: absolute;
    top: -70px;
    background-color: #423142;
    border-radius: 100%;
  }
  & img {
    width: 100px;
    height: 100px;
    margin: 10px;
    display: block;
  }
}

.login-input{
  position: relative;
  margin-bottom: 10px;
  border: 2px solid #ccc;
  border-radius: 3px;
  overflow: hidden;
  &.password{
    margin-bottom: 15px;
  }
  & .icon{
    background-color: #dedede;
    border-right: 1px solid #ccc;
    color: #777;
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 40px;

    & i { line-height: inherit; }
  }

  & input{
    border: 0;
    border-radius: 0;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    position: absolute;
    left: 40px;
    margin-top: 0;
    padding: 8px 10px;
    width: 270px;
    top: 0;
    // background-color: rgba(255, 255, 255, 0.9);
  }
}

.error-message {
  background-color: #F20D0D;
  text-align: center;
  color: #fff;
  padding: 0px 10px;
  font-size: 12px;
  border-radius: 3px;
  margin-bottom: 0;
  height: 0;
  transition: all 250ms;
  overflow: hidden;
  &.show{
    height: 28px;
    padding: 5px 10px;
    margin-bottom: 10px;
  }
}
.forgot-link{
  text-align: center;
  display: block;
  font-size: 14px;
  padding: 10px 0 0;
  color: #dedede;
  text-decoration: underline;
  cursor: pointer;
}

.forgot-password{
  p{
    font-size: 13px;
    line-height: 140%;
    color: #eee;
    text-align: center;
    margin-bottom: 30px;
  }
  a{
    color: #fff;
    text-decoration: underline;
    display: block;
    text-align: center;
    font-size: 14px;
    margin: 15px 0;
    cursor: pointer;

    &.disabled{
      opacity: .3;
      cursor: default;
    }
  }
}

.modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.modal-container {
  display: table-cell;
  vertical-align: middle;
}

.modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
  padding: 25px;

  label{
    font-size: 21px;
    font-weight: 600;
    margin-bottom: 20px;
    display: block;
  }
  p{
    margin: 0;
    font-size: 14px;
    color: #444;
  }
  b{ font-size: 15px; }
  .button{
    margin-top: 25px;
  }
}

.slide-item { display: inline-block; }
.slide-enter-active{ transition: all .3s linear; }
.slide-leave-active {
  display: none;
  transition: all 0s linear;
}
.slide-enter, .slide-leave-to{
  opacity: 0;
  transform: translateY(-20px);
}
</style>



// WEBPACK FOOTER //
// src/components/App/Login.vue